import CommonLang from "./common.lang";
import DeviceLang from "./device.lang";
import RequestLang from "./request.lang";
import ApplicationLang from "./application.lang";
import UserLang from "./user.lang";

export default {
  common: CommonLang,
  request: RequestLang,
  application: ApplicationLang,
  device: DeviceLang,
  user: UserLang,
};
